import React from 'react';
import { getDateFromItems, getFormated } from '../text-date-input.helpers';
export function useDate(state, props) {
    var _a, _b, _c, _d, _e;
    var emitChange = state.emitChange, isReadonly = state.isReadonly, isDisabled = state.isDisabled;
    var time = props.time;
    var _f = React.useState(false), error = _f[0], setError = _f[1];
    var _g = React.useState(((_a = getFormated(props.value)) === null || _a === void 0 ? void 0 : _a.d) || ''), day = _g[0], setDay = _g[1];
    var _h = React.useState(((_b = getFormated(props.value)) === null || _b === void 0 ? void 0 : _b.m) || ''), month = _h[0], setMonth = _h[1];
    var _j = React.useState(((_c = getFormated(props.value)) === null || _c === void 0 ? void 0 : _c.y) || ''), year = _j[0], setYear = _j[1];
    var _k = React.useState(((_d = getFormated(props.value)) === null || _d === void 0 ? void 0 : _d.h) || ''), hour = _k[0], setHour = _k[1];
    var _l = React.useState(((_e = getFormated(props.value)) === null || _e === void 0 ? void 0 : _e.i) || ''), minute = _l[0], setMinute = _l[1];
    function set(date) {
        var data = getFormated(date);
        setDay((data === null || data === void 0 ? void 0 : data.d) || '');
        setMonth((data === null || data === void 0 ? void 0 : data.m) || '');
        setYear((data === null || data === void 0 ? void 0 : data.y) || '');
        setHour((data === null || data === void 0 ? void 0 : data.h) || '');
        setMinute((data === null || data === void 0 ? void 0 : data.i) || '');
    }
    function setItem(value, input, event) {
        if (Number(value).isNan()) {
            emitChange(null, event);
        }
        var date;
        if (input == 'd') {
            date = getDateFromItems(time, value, month, year, hour, minute);
            setDay(value.toString());
            if (!date && month && year)
                setError(true);
        }
        else if (input == 'm') {
            date = getDateFromItems(time, day, value, year, hour, minute);
            setMonth(value.toString());
            if (!date && day && year)
                setError(true);
        }
        else if (input == 'y') {
            date = getDateFromItems(time, day, month, value, hour, minute);
            setYear(value.toString());
            if (!date && day && month)
                setError(true);
        }
        else if (input == 'h') {
            date = getDateFromItems(time, day, month, year, value, minute);
            setHour(value.toString());
            if (!date && day && month && year)
                setError(true);
        }
        else if (input == 'i') {
            date = getDateFromItems(time, day, month, year, hour, value);
            setMinute(value.toString());
            if (!date && day && month && year)
                setError(true);
        }
        if (date) {
            setError(false);
            emitChange(date, event);
        }
        else {
            emitChange(null, event);
        }
    }
    function onChange(event, input) {
        var value = String(event.target.value || '');
        if (Number(value) >= 0) {
            if (input === 'd' && value.length <= 2) {
                setItem(value, input, event);
            }
            else if (input === 'm' && value.length <= 2) {
                setItem(value, input, event);
            }
            else if (input === 'y' && value.length <= 4) {
                setItem(value, input, event);
            }
            else if (input === 'h' && value.length <= 2) {
                setItem(value, input, event);
            }
            else if (input === 'i' && value.length <= 2) {
                setItem(value, input, event);
            }
        }
    }
    function onClear() {
        setError(false);
        setDay('');
        setMonth('');
        setYear('');
        setHour('');
        setMinute('');
    }
    return {
        set: set,
        setItem: setItem,
        day: day,
        month: month,
        year: year,
        hour: hour,
        minute: minute,
        error: error,
        isErrored: function (i) { return false; },
        onChangeDay: function (e) { return onChange(e, 'd'); },
        onChangeMonth: function (e) { return onChange(e, 'm'); },
        onChangeYear: function (e) { return onChange(e, 'y'); },
        onChangeHour: function (e) { return onChange(e, 'h'); },
        onChangeMinute: function (e) { return onChange(e, 'i'); },
        onClear: onClear,
    };
}
